module.exports = __webpack_public_path__ + "images/banner1.56d2.png";